{
  "version": 1,
  "asset_id": "3cd524bc-92c3-4df4-ae9e-8764beadfde0",
  "project_id": "9fb22223-732b-4b0d-9eac-b115ce8cfd9c",
  "url": "/__l5e/assets-v1/3cd524bc-92c3-4df4-ae9e-8764beadfde0/stripe.svg",
  "r2_key": "a/v1/9fb22223-732b-4b0d-9eac-b115ce8cfd9c/3cd524bc-92c3-4df4-ae9e-8764beadfde0/stripe.svg",
  "original_filename": "stripe.svg",
  "size": 1876,
  "content_type": "image/svg+xml",
  "created_at": "2026-06-16T14:53:45Z"
}
